import { User } from '@/models/user';
import { UserRole } from '@/models/user-role';
import { UserCustomer } from '@/models/user-customer';

export class State {
    public user: User | null = null;
    public currentCustomerId: string | null = null;
    public currentSiteId: string | null = null;
}
